module.exports = __webpack_public_path__ + "media/28-01b.8ea074ba.mp4";